import { render, staticRenderFns } from "./sponsor_matching.vue?vue&type=template&id=697412fe&"
import script from "./sponsor_matching.vue?vue&type=script&lang=js&"
export * from "./sponsor_matching.vue?vue&type=script&lang=js&"
import style0 from "./sponsor_matching.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports